// 正则
import regular from '../../static/js/validate/regular'

/**
 * s-input 验证全部 格式为空/格式验证
 * @author 王硕
 * @param items
 * @param per
 * @returns {{msg: string, v: boolean, inputs}}
 */
export default (items, per) => {
    let v = true;
    let msg = '';
    let inputs = {};
    for (let key in items) {
        let item = items[key];

        item.tips = '';
        if (item.hide) {
            item.tips = '';
        } else if (!item.must && (item.value === '' || item.value === undefined || item.value === null)) {
        } else if (item.value) {
            // 格式验证
            if (item.regular && !regular[item.regular].test(item.value)) {
                item.tips = 'error';
                v = false;
                msg += `<p>${item.label}录入格式不正确；</p>`;
            }
        } else if (item.must &&!item.value) {
            // 为空验证
            item.tips = 'empty';
            v = false;
            msg += `<p>${item.label}不能为空；</p>`;
        }

        inputs[key] = item;
        try {
            per.$refs['sInput' + key][0].$forceUpdate()
        } catch (e) {

        }

    }

    return {
        v,
        msg,
        inputs
    };
}




// WEBPACK FOOTER //
// ./src/components/s-input/verifySAllItem.js